import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function BackButton() {
  const location = useLocation();
  const navigate = useNavigate();

  // Hide on home and admin
  if (location.pathname === "/" || location.pathname.startsWith("/admin")) return null;

  const handleBack = () => {
    if (window.history.length > 1) navigate(-1);
    else navigate("/");
  };

  return (
    <div className="max-w-7xl mx-auto px-4 lg:px-8 pt-4">
      <button
        type="button"
        onClick={handleBack}
        data-testid="back-button"
        className="inline-flex items-center gap-2 text-sm font-semibold text-fegray hover:text-fegreen transition-colors py-2 pr-3"
      >
        <ArrowLeft className="w-4 h-4" />
        Retour
      </button>
    </div>
  );
}
